/**
 * @generated SignedSource<<c9bfd71949ba23d22196c8a1cedf211a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InternBrandActivityChart_brand$data = {
  readonly metricsDaily: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly appSales: number;
        readonly appSessions: number;
        readonly date: any;
        readonly newAppUsers: number;
      };
    }>;
  };
  readonly " $fragmentType": "InternBrandActivityChart_brand";
};
export type InternBrandActivityChart_brand$key = {
  readonly " $data"?: InternBrandActivityChart_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"InternBrandActivityChart_brand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InternBrandActivityChart_brand",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filters",
          "value": {
            "os": {
              "isNull": true
            }
          }
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 30
        }
      ],
      "concreteType": "GraphQLBrandMetricDailyConnection",
      "kind": "LinkedField",
      "name": "metricsDaily",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLBrandMetricDailyEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GraphQLBrandMetricDaily",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "date",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "appSessions",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "appSales",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "newAppUsers",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "metricsDaily(filters:{\"os\":{\"isNull\":true}},first:30)"
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};

(node as any).hash = "16e6885082c62a58271550ce362446b3";

export default node;
